// components/skeletons/Bone.tsx
// Shared building blocks for the page skeletons: one shimmering block, and the
// keyframes it needs (render <SkeletonStyles /> once inside a skeleton).

import React from 'react';

export const SkeletonStyles: React.FC = () => (
  <style>{`
    .sk-bone { background: linear-gradient(90deg, #eef2f1 25%, #f6f8f7 50%, #eef2f1 75%); background-size: 200% 100%; animation: sk-shimmer 1.3s ease-in-out infinite; }
    @keyframes sk-shimmer { from { background-position: 200% 0; } to { background-position: -200% 0; } }
    .sk-bone.dark { background: linear-gradient(90deg, rgba(255,255,255,0.07) 25%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.07) 75%); background-size: 200% 100%; }
    @media (prefers-reduced-motion: reduce) { .sk-bone { animation: none; } }
  `}</style>
);

export const Bone: React.FC<{ w?: number | string; h?: number; r?: number | string; style?: React.CSSProperties; /** light-on-dark variant, for dark panels */ dark?: boolean }> = ({ w = '100%', h = 12, r = 6, style, dark }) => (
  <div className={dark ? 'sk-bone dark' : 'sk-bone'} style={{ width: w, height: h, borderRadius: r, flexShrink: 0, ...style }} />
);